import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Cell, ResponsiveContainer } from "recharts";

const BarChartComponent = ({
    datas = [
        {
            "type": "中文",
            "value": 20,
            "key": 1
        },
        {
            "type": "菜",
            "value": 10,
            "key": 2
        },
        {
            "type": "馬來",
            "value": 7,
            "key": 3
        },
        {
            "type": "越南",
            "value": 15,
            "key": 4
        },
        {
            "type": "泰文",
            "value": 15,
            "key": 5
        },
        {
            "type": "韓語",
            "value": 12,
            "key": 6
        }
    ]
}) => {

    const colors = [
        "#FADCD9",
        "#F9E2CF",
        "#FBE7D0",
        "#D9F2E6",
        "#CDE7F0",
        "#D6DBF5",
        "#E8DFF5",
        "#F5E1EE",
        "#FAF3DD",
        "#E9F6EC",
    ];

    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart
                width={600}
                height={400}
                data={datas}
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="type" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="value" name="借閱數量">
                    {datas.map((_, index) => (
                        <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                    ))}
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    )
}

export default BarChartComponent;
